import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { getAllSections, getAssetsBySectionId } from '../../../api';
import ProgressBar from '../../common/progress_bar';
import { withRouter } from 'react-router-dom';

import { Row } from 'react-bootstrap';
import { Empty, Table } from 'antd';
import './AssetsTasks.css';
import {
  searchAndDropDownFilters,
  SearchAndDropdownComponent,
  composeFilters,
  searchAndDropDownOnFilters,
  commonSorter,
  commonFilter,
} from 'utils/AntdTableFunctions';
import ProgressBarComp from 'containers/common/ProgressBarComp';

function AssetTask(props) {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  async function selectedSection(section, e) {
    e.preventDefault();

    const { match } = props;
    const { id } = props.project;
    let AssetsBySectionIdRequest = {};
    AssetsBySectionIdRequest.projectId = id;
    AssetsBySectionIdRequest.sectionId = section.id;

    const assets = await getAssetsBySectionId(AssetsBySectionIdRequest);
    const projectStatus = match.params.state;
    props.setSelectedAssets(assets);
    props.setSelectedSection(section);
    props.history.push(
      `/${projectStatus}/${id}/assettasks/allsections/${section.id}`
    );
  }

  useEffect(() => {
    let getData = async () => {
      const { id } = props.project;
      const sectionsData = await getAllSections(id);

      setSections(sectionsData);

      setLoading(false);
    };
    getData();
    return () => setLoading(true);
  }, [props]);

  const sectionFormatter = (text, record) => {
    return (
      <a href='#' onClick={(e) => selectedSection(record, e)}>
        {text}
      </a>
    );
  };
  const statusFormatter = (text, record) => {
    // return text === 100 ? (
    //   <ProgressBar percentage={text} color={'success'} />
    // ) : (
    //   <ProgressBar percentage={text} />
    // );
    return <ProgressBarComp
    progressBarProps={[{ bgcolor: 'green', taskPercent: Number(record.status).toFixed(2) },
    { bgcolor: 'gray', taskPercent: Number(record.inCompStatus).toFixed(2) },
    { bgcolor: 'yellow', taskPercent: Number(record.tempStatus).toFixed(2) }
    ]}
    style={{
      borderRadius: '.25rem',
      height: '1rem',
      overflow: 'hidden',
      fontSize: '.75rem',
      color: 'black'
    }}
    showtext={true}
  />
  };
  const columns = [
    {
      dataIndex: 'name',
      key: 'name',
      title: 'Section',
      render: sectionFormatter,
      filters: searchAndDropDownFilters('name', sections),
      ...SearchAndDropdownComponent(),
      onFilter: (value, record) =>
        searchAndDropDownOnFilters(value, record, 'name'),

      sorter: (a, b) => commonSorter(a, b, 'name'),
    },
    {
      dataIndex: 'noOfAssets',
      key: 'noOfAssets',
      title: '#Assets',

      filters: composeFilters('noOfAssets', sections),

      onFilter: (value, record) => commonFilter(value, record, 'noOfAssets'),
      sorter: (a, b) => commonSorter(a, b, 'noOfAssets'),
    },
    {
      dataIndex: 'status',
      key: 'status',
      title: 'Status',
      render: statusFormatter,
    },
  ];
  return (
    <div className='container-fluid'>
      {/* <Row
        className='justify-content-middle'
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          fontStyle: 'italic',
          fontWeight: 'bold',
          marginBottom: 12,
          marginTop: 20,
        }}
      >
        <i
          className='fa fa-info-circle'
          style={{ color: 'red', paddingRight: '3px' }}
          aria-hidden='true'
        ></i>{' '}
        Note: The % Calculations on this tab include tasks Signed and Marked
        N/A.
      </Row> */}

      <div className='row mb-5'>
        <div className='table-responsive  assets-task-container table '>
          <Table
            columns={columns}
            dataSource={sections}
            pagination={false}
            locale={{
              emptyText: loading ? (
                <Empty description={<h6>Loading</h6>} />
              ) : (
                <Empty description={<h6>No Assets Tasks Found</h6>} />
              ),
            }}
            loading={loading}
          />
        </div>
        <div />
      </div>
    </div>
  );
}

export default withRouter(AssetTask);